"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Pagination = function Pagination(_ref) {
  var cantFiles = _ref.cantFiles,
      gotoPage = _ref.gotoPage,
      nextPage = _ref.nextPage,
      pageIndex = _ref.pageIndex,
      previousPage = _ref.previousPage,
      setPageSize = _ref.setPageSize,
      size = _ref.size,
      totalPages = _ref.totalPages,
      rowsType = _ref.rowsType,
      explicitSize = _ref.explicitSize;

  var getSize = function getSize() {
    return explicitSize ? size : cantFiles instanceof Array ? cantFiles[0] : size;
  };

  var _useState = (0, _react.useState)("".concat(getSize(), " ").concat(rowsType)),
      _useState2 = _slicedToArray(_useState, 2),
      title = _useState2[0],
      setTitle = _useState2[1];

  var onChangeRows = function onChangeRows(number) {
    setPageSize(number);
    setTitle("".concat(number, " ").concat(rowsType));
  };

  var rows = typeof cantFiles === 'boolean' && cantFiles ? [10, 20, 30] : cantFiles;
  (0, _react.useEffect)(function () {
    setTitle(function (state) {
      return "".concat(state.split(' ')[0], " ").concat(rowsType);
    });
  }, [rowsType]);
  return /*#__PURE__*/_react.default.createElement("div", {
    variant: "outline-primary",
    className: "pagination"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.First, {
    // disabled={pageIndex === 0}
    title: "Primera p\xE1gina",
    onClick: function onClick() {
      return gotoPage(0);
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Prev, {
    // disabled={pageIndex === 0}
    title: "P\xE1gina anterior",
    onClick: function onClick() {
      return previousPage();
    }
  }), pageIndex > 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Item, {
    onClick: function onClick() {
      return gotoPage(0);
    }
  }, 1), pageIndex - 2 !== 0 && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Ellipsis, null)), pageIndex !== 0 && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Item, {
    onClick: function onClick() {
      return previousPage();
    }
  }, pageIndex), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Item, {
    active: true
  }, pageIndex + 1), totalPages !== pageIndex + 1 && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Item, {
    onClick: function onClick() {
      return nextPage();
    }
  }, pageIndex + 2), totalPages > pageIndex + 2 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pageIndex + 3 !== totalPages && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Ellipsis, null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Item, {
    onClick: function onClick() {
      return gotoPage(totalPages - 1);
    }
  }, totalPages)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Next, {
    onClick: function onClick() {
      return nextPage();
    },
    title: "Siguiente p\xE1gina"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Pagination.Last, {
    onClick: function onClick() {
      return gotoPage(totalPages - 1);
    },
    title: "\xDAltima p\xE1gina"
  })), rows.length && /*#__PURE__*/_react.default.createElement(_reactBootstrap.DropdownButton, {
    variant: "outline-primary",
    title: title
  }, rows.map(function (row) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
      key: row,
      onClick: function onClick() {
        return onChangeRows(row);
      }
    }, row, " ", rowsType);
  })));
};

var _default = Pagination;
exports.default = _default;
Pagination.propTypes = {
  cantFiles: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.number), _propTypes.default.bool]),
  gotoPage: _propTypes.default.func,
  nextPage: _propTypes.default.func,
  pageIndex: _propTypes.default.number,
  previousPage: _propTypes.default.func,
  rowsType: _propTypes.default.string,
  setPageSize: _propTypes.default.func,
  size: _propTypes.default.number,
  totalPages: _propTypes.default.number,
  explicitSize: _propTypes.default.bool
};
Pagination.defaultProps = {
  cantFiles: true,
  gotoPage: function gotoPage() {},
  nextPage: function nextPage() {},
  pageIndex: 1,
  previousPage: function previousPage() {},
  rowsType: 'filas',
  setPageSize: function setPageSize() {},
  size: 10,
  totalPages: 1,
  explicitSize: false
};